<!--
Auto-generated by: https://github.com/threlte/threlte/tree/main/packages/gltf
Command: npx @threlte/gltf@2.0.3 /Users/nrumak/Development/square-dt-labs/static/nrumak/S3_modified.glb -u -t -P
-->

<script module lang="ts">
  import { Group, Material, Mesh } from 'three';
  import { T, type Props } from '@threlte/core';
  import { useGltf, useSuspense } from '@threlte/extras';
  import type { Snippet } from 'svelte';

  const scale = 4;

  type GLTFResult = {
    nodes: {
      Mesh001: Mesh;
      Mesh001_1: Mesh;
      Mesh001_2: Mesh;
      Mesh001_3: Mesh;
      Mesh001_4: Mesh;
      Mesh001_5: Mesh;
      Mesh001_6: Mesh;
    };
    materials: {};
  };

  let modelUrl = '';

  const load = () => {
    const suspend = useSuspense();
    return suspend(useGltf<GLTFResult>(modelUrl));
  };

  export const preload = async (url: string) => {
    modelUrl = url;
    try {
      await load();
    } catch (err) {
      return console.error('Failed to load model', err);
    }
  };
</script>

<script lang="ts">
  let {
    fallback,
    error,
    children,
    ref = $bindable(),
    matcaps,
    fallbackMaterial,
    ...props
  }: Props<Group> & {
    ref?: Group;
    matcaps: {
      glass: Material;
      blackFrame: Material;
      ipadBezel: Material;
      blackOutline: Material;
      s3_screen: Material;
      s3_whitePlastic: Material;
      s3_glow: Material;
    };
    fallbackMaterial: Material;
    children?: Snippet<[{ ref: Group | undefined }]>;
    fallback?: Snippet;
    error?: Snippet<[{ error: Error }]>;
  } = $props();

  let materials: any = $state(matcaps);

  $effect(() => {
    materials = matcaps ?? {
      glass: fallbackMaterial,
      blackFrame: fallbackMaterial,
      ipadBezel: fallbackMaterial,
      blackOutline: fallbackMaterial,
      s3_screen: fallbackMaterial,
      s3_whitePlastic: fallbackMaterial,
      s3_glow: fallbackMaterial,
    };
  });

  const gltf = load();

  $effect(() => {
    materials = matcaps ?? {
      glass: fallbackMaterial,
      blackFrame: fallbackMaterial,
      ipadBezel: fallbackMaterial,
      blackOutline: fallbackMaterial,
      s3_screen: fallbackMaterial,
      s3_whitePlastic: fallbackMaterial,
      s3_glow: fallbackMaterial,
    };
  });
</script>

<T is={new Group()} bind:ref dispose={false} {...props} {scale}>
  {#await gltf}
    {@render fallback?.()}
  {:then gltf}
    <T.Group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
      <T.Mesh geometry={gltf.nodes.Mesh001.geometry} material={materials.s3_whitePlastic} />
      <!-- ipad bezel -->
      <T.Mesh geometry={gltf.nodes.Mesh001_1.geometry} material={materials.ipadBezel} />
      <!-- black frame -->
      <T.Mesh geometry={gltf.nodes.Mesh001_2.geometry} material={materials.blackFrame} />
      <!-- glass -->
      <T.Mesh geometry={gltf.nodes.Mesh001_3.geometry} material={materials.glass} />
      <!-- black outline -->
      <T.Mesh geometry={gltf.nodes.Mesh001_4.geometry} material={materials.blackOutline} position={[0, -0.001, 0]} />
      <!-- screen -->
      <T.Mesh geometry={gltf.nodes.Mesh001_5.geometry} material={materials.s3_glow} />
      <T.Mesh geometry={gltf.nodes.Mesh001_6.geometry} material={materials.s3_screen} />
    </T.Group>
  {:catch err}
    {@render error?.({ error: err })}
  {/await}
  {@render children?.({ ref })}
</T>
